import {
  FilterValue,
  MultiSelectFilter,
  SelectOption,
  StringArrayFilterValue,
} from "../../types/filter";
import { TrackingProps } from "../../types/component";
import { PillMultiSelect } from "../FilterPill/PillMultiSelect";
import {
  getSelectedFilterValue,
  updatedFilterValueFromValues,
} from "../../utils/filter/filtervalue";
import { createFilterValueFromMultiSelectOption } from "../../utils/filter/selectfiltervalue";

interface InputMultiSelectPillDesktopProps {
  filter: MultiSelectFilter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  tracking: TrackingProps;
}

export const InputMultiSelectPillDesktop = ({
  filter,
  filterValues,
  setFilterValues,
  tracking,
}: InputMultiSelectPillDesktopProps) => {
  const { id, defaultValue } = filter;
  const selected = getSelectedFilterValue(
    id,
    filterValues,
    defaultValue
  ) as StringArrayFilterValue;
  const handleOnChange = (option: SelectOption, isSelected: boolean) => {
    const value = createFilterValueFromMultiSelectOption(
      filter.id,
      option,
      selected,
      isSelected
    );
    setFilterValues(updatedFilterValueFromValues(filterValues, filter, value));
  };
  return (
    <PillMultiSelect
      filter={filter}
      filterValue={selected}
      selected={selected}
      onChange={handleOnChange}
      tracking={tracking}
    />
  );
};
